let count;

if (window.matchMedia('(max-width: 767px)').matches) {
  let count = 2;
} else if (window.matchMedia('(min-width:768px)').matches) {
  let count = 3;
}

const mySwiper4 = new Swiper('.swiper-container3', {
  loop: true, // ループ有効
  speed: 300,
  effect: 'fade',
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // 前後の矢印
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});




////////////////// 慣性スクロール
if (window.matchMedia('(max-width: 767px)').matches) {
  //スマホ処理
  console.log("スマホだよ")
} else if (window.matchMedia('(min-width:768px)').matches) {
  const lenis = new Lenis({
    duration: 1.2, // アニメーションの継続時間
    direction: 'vertical', // 方向
    gestureDirection: 'vertical',
    smooth: true, // スムーススクロールの有効・無効を設定
    smoothTouch: false, // タッチスクロール時のスムーススクロールの有効・無効を設定。(タッチデバイス本来の滑らかさを模倣することは不可能であるため、デフォルト無効)
    touchMultiplier: 2,
  })
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf)
}


//////////////////// fade all
const list = document.querySelectorAll(".fade")
list.forEach(function(element, i) {
  gsap.fromTo(
    list[i], // アニメーションさせる要素
    {opacity: 0,y: 30,},
    {
      opacity: 1,y: 0,duration: 0.3,
      scrollTrigger: {
        trigger: list[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
    }
  );
});


//////////////////// about text
const list_text_all = document.querySelectorAll(".heroTextAnim")
list_text_all.forEach(function(element, i) {
  list_text_all[i].innerHTML = list_text_all[i].textContent.replace(/\S/g, "<span class='letter" + i + "'>$&</span>");
  let letter = document.querySelectorAll(".letter" + i);
  gsap.fromTo(
    letter, // アニメーションさせる要素
    {opacity: 0,y: 10,},
    {
      opacity: 1,y: 0,duration: 0.6,
      scrollTrigger: {
        trigger: list_text_all[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
      stagger: {
        each: .01, // 遅延させる時間
      }
    }
  );
});



//////////////////////  パララックス

if (window.matchMedia('(max-width: 767px)').matches) {
  //スマホ処理
  console.log("スマホだよ")
} else if (window.matchMedia('(min-width:768px)').matches) {
  gsap.fromTo(
    ".ccg_about_bg", // アニメーションを適用する画像要素を取得
    {
      yPercent: 0, // パララックス前の要素の位置
    },
    {
      yPercent: -10, // 上に要素の幅の1/5分移動
      ease: "ease", // イージングなし
      scrollTrigger: {
        trigger: ".ccg_about_bg", // アニメーションのトリガー要素
        start: "top bottom", // アニメーション開始位置
        end: "bottom top", // アニメーション終了位置
        scrub: 0.5, // 動作を遅らせる
      },
    }
  );
}